import { API } from '@typings/internal';

const FORBIDDEN_CODES = [401, 403];

export const isResourceForbidden = <T>(response: API.SuccessResponse<T> | API.FailedResponse<T>) =>
  FORBIDDEN_CODES.includes(response.statusCode);
